/** Sidebar section matching — active highlight and same-section click handling. */

/** True when `pathname` sits at, or inside, the section rooted at `to`. */
export function isNavSectionActive(pathname, to) {
  const path = String(pathname || "");
  if (!to) return false;
  if (to === "/inbound") return path.startsWith("/inbound");
  return path === to || path.startsWith(`${to}/`);
}

/**
 * Sections such as Inbox own their route state (open conversation, filters).
 * Navigating to the section root discards that state and starts a fresh load,
 * so the click is ignored while the user is already inside the section.
 */
export function shouldIgnoreSectionNav({ pathname, to, preserveState }) {
  return Boolean(preserveState) && isNavSectionActive(pathname, to);
}
